import React, { useEffect, useState, constructor } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, InputNumber } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { ITeachClassCourse, listTeachClassCourses, createTeachClassCourse, updateTeachClassCourse, deleteTeachClassCourse, updateStatusTeachClassCourse } from '../../service/api/teachClass';
import { IStudent, listStudents } from '../../service/api/student';
import { ITeacher, listTeachers } from '../../service/api/teacher';
import { ICourseDefinition, listCourseDefinitions } from '../../service/api/courseDefinition';
import { IClassroom, listClassroomsByStoreId } from '../../service/api/classroom';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { FormInstance } from 'antd/lib/form/Form';
const { confirm } = Modal;
const { Option } = Select;
// import queryString from 'query-string';

// const values = queryString.parse(window.location.search)

function getUrlParam(name: string, str: string) {
  const paramUrl = str.split('?');
  const params = paramUrl[1].split('&');
  for (var i = 0; i < params.length; i++) {
    const value = params[i].split('=');
    if (value[0] == name) {
      return value[1];
    }
  }
  return null;
}

const TeachClassCourseView = (props: any) => {
  const [defaultTeacherId, setDefaultTeacherId] = useState<number>();
  const [teachClassId, setTeachClassId] = useState<any>();
  const [teachClassCourses, setTeachClassCourses] = useState<IStudent[]>();
  const [teachClassCourseDetail, setTeachClassCourseDetail] = useState<ITeachClassCourse>();
  const [teachClassCourseId, setTeachClassCourseId] = useState<number>();
  const [storeId, setStoreId] = useState<any>();
  const [teachClassCourseVisible, setTeachClassCourseVisible] = useState(false);
  const [students, setStudents] = useState<IStudent[]>();
  const [teachers, setTeachers] = useState<ITeacher[]>();
  const [courseDefinitions, setCourseDefinitions] = useState<ICourseDefinition[]>();
  const [classroooms, setClassrooms] = useState<IClassroom[]>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [stopModal, setStopModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const formRef = React.createRef<FormInstance>();
  const stopFormRef = React.createRef<FormInstance>();
  const columns = [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '教师',
      dataIndex: 'teacherName',
      key: 'teacherName',
    },
    {
      title: '课程',
      dataIndex: 'courseDefinitionName',
      key: 'courseDefinitionName',
    },
    {
      title: '计划上课时间',
      dataIndex: 'planStartTime',
      key: 'planStartTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm') : <>&mdash;</>
      },
    },
    {
      title: '消耗课程数',
      dataIndex: 'costValue',
      key: 'costValue',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (text: any, record: any) => {
        if (record.status == 'stop') {
          return <span style={{ color: 'gray' }}>已停课</span>
        } else if (record.status == 'plan') {
          return <span style={{ color: 'blue' }}>未开始</span>
        } else if (record.status == 'finish') {
          return <span style={{ color: 'green' }}>已完成</span>
        }
      }
    },
    {
      title: '操作',
      key: 'action',
      render: (text: any, record: any) => {
        if (record.status == 'stop') {
          return <Space size="middle">
            <a onClick={() => {
              setTeachClassCourseDetail(record);
              setTeachClassCourseVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onPlan(e, record) }}>恢复 </a>
            <a onClick={e => { onDelete(e, record) }}>删除 </a>
          </Space>
        } else if (record.status == 'plan') {
          return <Space size="middle">
            <a onClick={() => {
              setTeachClassCourseDetail(record);
              setTeachClassCourseVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onStop(e, record) }}>停课 </a>
            <a onClick={e => { onDelete(e, record) }}>删除 </a>
          </Space>
        } else {
          return <Space size="middle">
            <a onClick={() => {
              setTeachClassCourseDetail(record);
              setTeachClassCourseVisible(true);
            }}>编辑 </a>
            <a onClick={e => { onDelete(e, record) }}>删除 </a>
          </Space>
        }
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (teachClassCourseDetail) {
      let copyFormData = JSON.parse(JSON.stringify(teachClassCourseDetail))
      if (typeof (copyFormData.planStartTime) === 'string') {
        copyFormData.planStartTime = moment(new Date(teachClassCourseDetail.planStartTime));
      }
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        formRef.current!.setFieldsValue(copyFormData);
      }, 100);
    }
  }, [teachClassCourseDetail]);

  const loadData = () => {
    setTeachClassId(getUrlParam('teachClassId', window.location.href));
    const storeIdd = getUrlParam('storeId', window.location.href);
    setStoreId(storeIdd);
    setDefaultTeacherId(parseInt(getUrlParam('teacherId', window.location.href)!));
    console.log('csn:' + getUrlParam('teachClassId', window.location.href));
    listTeachClassCourses(getUrlParam('teachClassId', window.location.href)).then((info: any) => {
      setTeachClassCourses(info?.data);
      console.log("info:" + JSON.stringify(info.data));
    });
    listStudents().then((info: any) => {
      setStudents(info?.data);
    });
    listTeachers().then((info: any) => {
      setTeachers(info?.data);
    });
    listCourseDefinitions().then((info: any) => {
      setCourseDefinitions(info?.data);
    });
    listClassroomsByStoreId(storeIdd).then((info: any) => {
      setClassrooms(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    if (teachClassCourseDetail) {
      updateTeachClassCourse({
        ...values,
        id: teachClassCourseDetail.id,
        teachClassId: teachClassId
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    } else {
      createTeachClassCourse({
        ...values,
        teacherId: values.teacherId ? values.teacherId : defaultTeacherId,
        teachClassId: teachClassId
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          setLoading(false);
          loadData();
        }
      });
    }
  };

  const onFinishStop = (values: any) => {
    setLoading(true);
    updateStatusTeachClassCourse(teachClassId, teachClassCourseId!, 'stop', values.remark!, values.notice!, values.noticeRemark!)
    .then((info: any) => {
      if (info) {
        message.success("操作成功");
        setLoading(false);
        loadData();
      }
    });
    setStopModal(false);
  };

  const onPlan = (e: any, item: ITeachClassCourse) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要恢复该课程吗',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        updateStatusTeachClassCourse(item.teachClassId, item.id, 'plan', undefined, undefined, undefined).then((info: any) => {
          if (info) {
            message.success("操作成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onStop = (e: any, item: ITeachClassCourse) => {
    e.stopPropagation();
    setStopModal(true);
    setTeachClassCourseId(item.id);
  }

  const onDelete = (e: any, item: IStudent) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要删除该班级课程吗？删除后无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteTeachClassCourse(item.id, teachClassId).then((info: any) => {
          if (info) {
            console.log("info:" + JSON.stringify(info));
            message.success("删除成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setTeachClassCourseDetail(undefined);
    setTeachClassCourseVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  function range(start: number, end: number) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  // function disabledDate(current:any) {
  //   // Can not select days before today and today
  //   return current && current < moment().endOf('day');
  // }

  // function disabledDateTime() {
  //   return {
  //     disabledHours: () => range(0, 24).splice(4, 20),
  //     disabledMinutes: () => range(30, 60),
  //     disabledSeconds: () => [55, 56],
  //   };
  // }

  // 下拉框值
  const teacherOptions = teachers?.map((teacher) =>
    <Option key={teacher.id} value={teacher.id}>{teacher.name}</Option>);

  // 下拉框值
  const classroomOptions = classroooms?.map((classrooom) =>
    <Option key={classrooom.id} value={classrooom.id}>{classrooom.name}</Option>);

  // 下拉框值
  const courseDefinitionOptions = courseDefinitions?.map((courseDefinition) =>
    <Option key={courseDefinition.id} value={courseDefinition.id}>{courseDefinition.name}</Option>);


  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={[<Link to={'/app/schedule'}>排课管理</Link>, <Link to={'/app/schedule?index=2'}>班级管理</Link>, '班级课程']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Card title={decodeURI(getUrlParam('teachClassName', window.location.href)!)} bordered={false} extra={
              <Button type="primary" onClick={() => {
                setTeachClassCourseVisible(true);
              }} icon={<PlusOutlined />}>
                新增
              </Button>
            }>
              <Table dataSource={teachClassCourses} columns={columns} pagination={false} />
            </Card>
          </div>
        </Col>
      </Row>
      <Drawer
        title={teachClassCourseDetail ? "编辑班级课程" : "新增班级课程"}
        visible={teachClassCourseVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="teacherId"
                label="教师"
                rules={[{ required: false, message: '请选择负责该课程的教师' }]}
              >
                <Select placeholder="请选择负责该课程的教师"
                  showSearch
                  defaultValue={defaultTeacherId}
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {teacherOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="classroomId"
                label="教室"
                rules={[{ required: true, message: '请选择上课的教室' }]}
              >
                <Select placeholder="请选择上课的教室"
                  showSearch
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {classroomOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="courseDefinitionId"
                label="课程"
                rules={[{ required: true, message: '请选择课程' }]}
              >
                <Select placeholder="请选择课程"
                  showSearch
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {courseDefinitionOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: false, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="planStartTime"
                label="上课时间"
                rules={[{ required: true, message: '请选择上课时间' }]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm"
                  // disabledDate={disabledDate}
                  // disabledTime={disabledDateTime}
                  showTime={{ defaultValue: moment('00:00:00', 'HH:mm') }}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="costValue"
                label="消耗课时数"
                rules={[{ required: true, message: '请输入消耗课时数' }]}
              >
                 <InputNumber min={1} max={10} step={0.5}/>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="costHour"
                label="上课时长"
                rules={[{ required: true, message: '请输入上课时长' }]}
              >
                 <InputNumber min={1} max={10} step={0.5}/>
              </Form.Item>
            </Col>
            {teachClassCourseDetail ? <></> :
              <Col span={8}>
                <Form.Item
                  name="everyWeekCount"
                  label="是否之后每周都执行的次数"
                  rules={[{ required: false, message: '请输入次数' }]}
                >
                  <InputNumber min={1} max={50} />
                </Form.Item>

              </Col>}
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
      <Modal title="停课原因" visible={stopModal} footer={[]}>
        {/* <Input placeholder="请输入停课原因" onChange={(e) => { setStopRemark(e.target.value) }} /> */}
        <Form onFinish={onFinishStop} ref={stopFormRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="remark"
                label="停课原因"
                rules={[{ required: false, message: '请输入停课原因' }]}
              >
                 <Input placeholder="请输入停课原因" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
            <Form.Item
                name="notice"
                label="是否通过微信服务号通知相关学员"
                rules={[{ required: true, message: '请选择' }]}
              >
                <Radio.Group >
                  <Radio value={1}>是</Radio>
                  <Radio value={0}>否</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="noticeRemark"
                label="通知学员的原因"
                rules={[{ required: false, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>确定</Button>
                <Button htmlType="button" onClick={() => { 
          if (stopFormRef.current) {
            stopFormRef.current!.resetFields();
          }
          setStopModal(false);
       }}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default TeachClassCourseView;
